import { getUpdatedMapSize, SearchMapAction, SearchMapActionTypes, SearchMapState } from './'

export function SearchMapReducer(state: SearchMapState, action: SearchMapAction): SearchMapState {
  switch (action.type) {
    case SearchMapActionTypes.setView: {
      const { size, ...restPayload } = action.payload
      return { ...state, ...restPayload, ...getUpdatedMapSize(state.size, size) }
    }
    case SearchMapActionTypes.setZoom: {
      return { ...state, ...(action.zoom && { zoom: action.zoom }) }
    }
    case SearchMapActionTypes.setCenter: {
      return { ...state, ...(action.pos && { center: action.pos }) }
    }
    case SearchMapActionTypes.setBounds: {
      return { ...state, ...(action.bounds && { bounds: action.bounds }) }
    }
    case SearchMapActionTypes.setPoints: {
      const points = action.payload.map((p) => ({
        type: 'Feature',
        properties: {
          ...p,
          cluster: false,
        },
        geometry: {
          type: 'Point',
          coordinates: [p.longitude, p.latitude],
        },
      }))
      return { ...state, points }
    }
    case SearchMapActionTypes.setSize: {
      return {
        ...state,
        ...getUpdatedMapSize(state.size, action.size),
      }
    }
    case SearchMapActionTypes.openPopup: {
      return { ...state, popup: action.payload }
    }
    case SearchMapActionTypes.closePopup: {
      return { ...state, popup: null }
    }
    case SearchMapActionTypes.setIsMouseOverPopup: {
      return { ...state, isMouseOverPopup: action.payload }
    }
    case SearchMapActionTypes.hydrate: {
      return { ...state, ...action.payload }
    }
    default: {
      return { ...state }
    }
  }
}
